import { useRef, useState } from 'react';

import { LoadingButton } from '@mui/lab';
import { Box, Button, Typography } from '@mui/material';

import { UploadButton } from 'components/upload';
import { useMutateImportacao } from 'pages/cadastro/loja/hooks/importacao/useMutateImportacao';

export function LojaImportacaoUploadBtn() {
    const [file, setFile] = useState<File | null>(null);
    const inputRef = useRef<HTMLInputElement>(null);
    const { handleSubmit, isLoading } = useMutateImportacao({ setFile, file, inputRef });

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'stretch', sm: 'flex-start' }, gap: 1, flex: 1 }}>
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    gap: 2,
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: { xs: 'stretch', sm: 'flex-start' },
                }}
            >
                <UploadButton label="Selecionar Arquivo" disabled={isLoading} onChange={(file) => setFile(file)} accept=".csv" inputRef={inputRef} />

                <LoadingButton variant="contained" loading={isLoading} disabled={!file} onClick={handleSubmit}>
                    Enviar
                </LoadingButton>

                <Button variant="contained" disabled={!file} onClick={() => setFile(null)}>
                    Limpar
                </Button>
            </Box>

            {file && (
                <Typography variant="caption" component="p">
                    {file.name}
                </Typography>
            )}

            <Typography variant="caption" component="p">
                *São aceitos somente arquivos em formato .csv
            </Typography>
        </Box>
    );
}
